module.exports = __webpack_public_path__ + "images/tour-kyle.gif";